var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnAppstore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 168.103,
    height: 40.444,
    viewBox: "0 0 168.103 40.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-2",
    width: 28.662,
    height: 28.732,
    x: 21.853,
    y: 5.056
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168.103,
    height: 40.444,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M8 0h152.10344828c4.4153202 0 8 3.5846798 8 8v24.44444444c0 4.4153202-3.5846798 8-8 8H8c-4.4153202 0-8-3.5846798-8-8V8c0-4.4153202 3.5846798-8 8-8z"
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 0,
    style: {
      whiteSpace: "pre"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 68.008,
    y: 31.324,
    fill: "rgb(255,255,255)",
    fontFamily: "Montserrat SemiBold",
    fontSize: 15,
    fontWeight: 600,
    style: {
      whiteSpace: "pre",
      textTransform: "none"
    }
  }, "App Store")), /*#__PURE__*/React.createElement("text", {
    fontSize: 0,
    style: {
      whiteSpace: "pre"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 72.677,
    y: 16.056,
    fill: "rgb(255,255,255)",
    fontFamily: "Montserrat Medium",
    fontSize: 8,
    fontWeight: 500,
    style: {
      whiteSpace: "pre",
      textTransform: "none"
    }
  }, "Cons\xEDguelo en el"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-2"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.662,
    height: 28.732,
    x: 21.853,
    y: 5.056,
    fill: "none",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M48.16163793 26.12037037c-.25215517.50555556-.42025862 1.09537037-.6724138 1.60092593-.7564655 1.68518518-1.84913792 3.20185185-3.10991379 4.63425926-.58836206.58981481-1.26077586 1.09537037-2.1012931 1.26388888-.6724138.16851852-1.34482758.08425926-2.01724138-.08425925l-1.51293103-.50555556c-1.51293104-.58981482-3.02586207-.50555556-4.45474138.08425926-.58836207.25277778-1.17672414.4212963-1.84913793.58981481-.92456897.16851852-1.76508621 0-2.52155173-.58981481-.67241379-.50555556-1.26077586-1.09537037-1.7650862-1.76944445-1.42887931-1.76944444-2.52155173-3.7074074-3.19396552-5.89814814-.58836207-1.76944445-.84051724-3.5388889-.75646552-5.3925926.08405173-1.93796296.58836207-3.7074074 1.84913793-5.22407407 1.26077586-1.51666667 2.7737069-2.44351852 4.70689655-2.6962963.92456897-.08425926 1.76508621 0 2.60560345.33703704.6724138.25277778 1.34482759.50555556 2.1012931.67407407.16810345.08425926.42025863.08425926.58836208.16851852.25215517.08425926.58836206 0 .84051724-.08425926.75646551-.25277777 1.51293103-.50555555 2.18534482-.75833333.84051725-.25277778 1.68103449-.50555556 2.60560345-.50555556 1.59698276.08425926 3.1099138.50555556 4.37068966 1.51666667.50431034.4212963.92456896.8425926 1.26077586 1.34814815-2.18534483 1.34814815-3.36206897 3.28611111-3.19396552 5.89814815.3362069 2.52777778 1.7650862 4.21296296 4.03448276 5.39259259z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M42.1099138 5.22407407V6.4037037c-.16810346 1.8537037-1.17672414 3.20185186-2.52155173 4.38148149-.6724138.50555555-1.34482759.92685185-2.18534483 1.09537037-.16810345 0-.42025862.08425925-.58836207.08425925h-.58836207c-.08405172-.4212963-.08405172-.84259259 0-1.17962962.42025862-2.275 1.68103449-3.96018519 3.69827587-4.9712963.67241379-.33703704 1.34482758-.50555556 2.1012931-.58981482h.08405172z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAppstore);
export default __webpack_public_path__ + "static/media/btn-appstore.197c9c87f46bc3e6b29f8509bf1287b1.svg";
export { ForwardRef as ReactComponent };